
import { useForm, Controller } from "react-hook-form";
import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {  UpdateControlInput } from "src/validation.ts/controls";
import { toast } from "react-toastify";
import { fetchDataApiRefrence, fetchAllDataApiCoso as getCoso } from "../../services/reference";
import { fetchOneControlApi as getControl } from "../../services/reference";
import { updateControlBasic } from "../../services/reference";
import "./updateControl.css";
import Button from "src/components/Buttons/Button";
import { AiOutlineInfoCircle as InformationCircleIcon } from "react-icons/ai";
import CreateAccountType from "./component/AddAccountType";

import LoadingScreen from "src/Loading/LoadingScreen";
import ConfirmationModal from "./component/unSaveCmponent";

 
const Tooltip: React.FC<{ content?: any; direction?: string; className?: string; tagName?: string; background?: string; children?: any }>
  = ({ children }) => <>{children}</>;


const Label: React.FC<React.LabelHTMLAttributes<HTMLLabelElement>> = (props) => <label {...props} />;
const ErrorMessage: React.FC<{ errors: any; name: string; render: ({ message }: { message: any }) => any }>
  = ({ errors, name, render }) => {
    const msg = errors?.[name]?.message;
    return msg ? render({ message: msg }) : null;
  };
const ActionsLayout: React.FC<{ children?: any; className?: string }> = ({ children, className = "" }) => <div className={`d-flex gap-2 align-items-center ${className}`}>{children}</div>;
const Table: React.FC<{ children?: any; className?: string }> = ({ children, className = "" }) => <div className="table-responsive"><table className={`table ${className}`}>{children}</table></div>;
const TableBody: React.FC<{ children?: any; className?: string }> = ({ children }) => <tbody>{children}</tbody>;
const TableRow: React.FC<{ children?: any; className?: string }> = ({ children, className = "" }) => <tr className={className}>{children}</tr>;
const Separator: React.FC<{ className?: string }> = ({ className = "" }) => <hr className={className} />;





const UpdateControlPage = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { id } = useParams<{ id: string }>();
    let {
        register,
        handleSubmit,
        setValue, // Destructure setValue from useForm
        getValues, // Add getValues function
        formState: { errors },
        reset, // Add reset function
    } = useForm<UpdateControlInput>({
        defaultValues: {
            name: "",
            description: "",
            objective: "",
            risk_response: "",
            where_factor: "",
            frequency: undefined,
            timing: "",
            type: undefined,
            method: undefined,
            entityLevel: undefined,
            keyControl: "",
            antiFraud: "",
            icof_id: "",
        }
    });

    const [showErrors, setShowErrors] = useState<boolean>(true);
    const [controlCBEArr, setControlCBEArr] = useState([
        { functionName: "", domainName: "", functionId: "", domainId: "" },
    ]);

    const [riskSelectionError, setRiskSelectionError] = useState<string | null>(null);

    // Navigation helpers placeholder
    const switchToCatalog = () => navigate('/standards');
    const navigateTo = (path: string) => navigate(path);

    let description_txt =
        ': وصف الاجراء يجب ان يتضمن التالى \n  الاسم الوظيفى للقائم بالاجراء تعريف \n وصف الاجراء كما هو مذكور مثلا فى السياسات و الاجراءات دورية الاجراء " بشكل يومى او شهرى او سنوى الخ الهدف من الاجراء " هل هو لمنع حدوث الخطر ام لاكتشاف حدوث الخطر ام لتصحيح العواقب او نتائج حدوث الخطر';

    let classification_txt = `الإجراء الرئيسي يعتبر خط الدفاع الأول أو أول إجراء يتم اتخاذه لمنع أو اكتشاف أو تصحيح حدوث الخطر
        الإجراء البديل هو الإجراء الذي يتم تفعيله في حالة عدم تفعيل أو فعالية الإجراء الرئيسي
        مثل في حالة حدوث انقطاع للكهرباء يتم تشغيل مولدات الكهرباء
        الإجراء المكمل هو الإجراء الذي يتم تفعيله بالتوازي مع الإجراء الرئيسي لاكتمال فعالية منع أو اكتشاف أو تصحيح حدوث الخطر
        `;

    let level_txt = `هل الاجراء مرتبط بمؤشرات اداء رئيسية او اهداف استراتيجية او بممارسات مجلس الادارة و الجمعية العمومية و او تطبيقات الحوكمة على مستوى البنك 
        ام مرتبط بالعمليات التشغيلية اليومية و الدورية بقطاعات و ادارات و وحدات و فروع البنك`;

    const [department, setDepartment] = useState("");
    const [dependInfo, setDependInfo] = useState("");
    const [head_department, setHead] = useState("");

    const [system, setSystem] = useState(null);
    const [selectedMethod, setSelectedMethod] = useState("");

    let default_process: any = [{ label: "", value: "" }];
    let [process, setProcess] = useState(default_process);

    let default_functions: any = [{ label: "", value: "" }];
    let [fun, setFun] = useState(default_functions);
    //let [users, setUsers] = useState([]);
    const [isLoadingButton, setLoadingButton] = useState(false);

  
    interface Assertion {
        id: any;
        name: string;
        account_type?: string;
        C?: boolean;
        E?: boolean;
        A?: boolean;
        V?: boolean;
        O?: boolean;
        P?: boolean;
    }
    let [assertions, setAsserations] = useState<Assertion[]>([]);
    let [control, setControl] = useState<any>(null);
    const [showCOSO, setShowCOSO] = useState(false);
    const [showCOBIT, setShowCOBIT] = useState(false);
    const [showCBE, setShowCBE] = useState(false);

    let pointsArr: any = [
        {
            component: "",
            principle: "",
            point_id: "",
            point_name: "",
        },
    ];
    let practiceArr: any = [
        {
            domain: "",
            process: "",
            practice_id: "",
            practice_name: "",
        },
    ];

    let nistArr: any = [{ category: "", sub_cat: "", nist_id: "" }];
    let isoArr: any = [{ code: "", name: "", iso_id: "" }];

    let default_risks_control: any = [{ label: "", value: "" }];
    let [risks_control, setRisksControl] = useState(default_risks_control);

    const [oldPointsArr, setPoints] = useState(pointsArr);
    const [oldPracticesArr, setPractices] = useState(practiceArr);

    const [oldNistArr, setNISTs] = useState(nistArr);
    const [oldIsoArr, setIsos] = useState(isoArr);

    const [icof_checkbox, setChecked] = useState(false);
    let [icof, setIcof] = useState<Assertion | null>(null);

    const [loading, setLoading] = useState<boolean>(true);
    const [isDataLoading, setIsDataLoading] = useState(true);
    const [error, setError] = useState<boolean>(false);
    const [errorMsg, setErrorMsg] = useState<string>("");

   const [permissionsShow, setPermissionsShow] = useState(false);
    const [permissionsError, setPermissionsError] = useState(false);

    const [controlReferenceOptions, setControlReferenceOptions] = useState([]);
    const [selectedControls, setSelectedControls] = useState([]);


    const fetchControl = async () => {
        try {
            const data = await getControl(`controls/${id}`);
            let controlData = data?.data;
           // console.log('Control data received:', controlData);
            setControl(data?.data);

            if (controlData) {
                let controlFunction: any = controlData?.ControlFunctions;
                if (controlFunction && controlFunction.length > 0) {
                    const newControlsFunction = controlFunction.map((e: any) => ({
                        value: e.Function.id,
                        label: e.Function.name,
                    }));

                    setFun(newControlsFunction);
                }

                let controlProcess: any = controlData?.ControlProcesses;
                if (controlProcess && controlProcess.length > 0) {
                    const newControlsProcess = controlProcess.map((e: any) => ({
                        value: e.process.id,
                        label: e.process.name,
                    }));

                    setProcess(newControlsProcess);
                }

                let risks_arr: any = controlData?.RiskControls;
                if (risks_arr && risks_arr.length > 0) {
                    // Create a new array to store the updated values
                    const newRisks = risks_arr.map((e: any) => ({
                        value: e.risk.id,
                        label: e.risk.name,
                    }));

                    setRisksControl(newRisks);
                }

                let coso_arr: any = controlData?.ControlCoso;
                if (coso_arr && coso_arr.length > 0) {
                    // Create a new array to store the updated values
                    const newCosos = coso_arr.map((e: any) => ({
                        component: e.coso?.CosoPrinciple?.CosoComponent?.name,
                        principle: e?.coso?.CosoPrinciple?.name,
                        point_id: e?.coso?.id,
                        point_name: e.coso?.name,
                    }));

                    setPoints(newCosos);
                }


                if (controlData?.ControlCBE && controlData?.ControlCBE?.length > 0) {
                    const cbeArr = controlData?.ControlCBE?.map((cbe: any) => ({
                        functionName: cbe.cbe?.CBEFunction?.name || '', 
                        domainName: cbe.cbe?.name || '',
                        functionId: cbe.cbe?.CBEFunction?.id || '',
                        domainId: cbe.cbe?.id || '',
                    }));
                    setControlCBEArr(cbeArr || []);
                }

                if (controlData) {
                    // Load Control References
                    if (controlData.controlReferences) {
                        const controlReferenceIds = controlData.controlReferences.map((ref: any) => ({
                            value: ref.id,
                            label: ref.name
                        }));
                        const referenceNames = controlData.controlReferences
                            .map((ref: any) => ref.name ? String(ref.name).toLowerCase() : "")
                            .filter((name: string) => name);
                        setShowCOSO(referenceNames.some((name: string) => name.includes("coso")));
                        setShowCOBIT(referenceNames.some((name: string) => name.includes("cobit")));
                        setShowCBE(referenceNames.some((name: string) => name.includes("cbe")));
                        setSelectedControls(controlReferenceIds);
                    }}

                let cobit_arr: any = controlData?.ControlCobit;
                if (cobit_arr && cobit_arr.length > 0) {
                    // Create a new array to store the updated values
                    const newCobits = cobit_arr.map((e: any) => ({
                        domain: e?.cobit?.CobitProcess?.CobitDomain.name,
                        process: e?.cobit?.CobitProcess?.name,
                        practice_id: e?.cobit?.id,
                        practice_name: e?.cobit?.name,
                    }));

                    setPractices(newCobits);
                }

                let nist_arr: any = controlData?.ControlNist;
                if (nist_arr && nist_arr.length > 0) {
                    // Create a new array to store the updated values
                    const newNists = nist_arr.map((e: any) => ({
                        sub_cat: e?.nist?.name,
                        nist_id: e?.nist?.id,
                        category: e?.nist?.NistCat?.name,
                    }));

                    setNISTs(newNists);
                }

                let iso_arr: any = controlData?.ControlIso;
                if (iso_arr && iso_arr.length > 0) {
                    // Create a new array to store the updated values
                    const newIsos = iso_arr.map((e: any) => ({
                        name: e?.iso?.name,
                        iso_id: e?.iso?.id,
                        code: e?.iso?.code,
                    }));

                    setIsos(newIsos);
                }

                if (controlData?.department !== undefined && controlData?.department != "") {
                    setDepartment(controlData?.department?.id);
                }

                setDependInfo(controlData?.dependInfoId);

                if (controlData?.head_department !== undefined && controlData?.head_department != "") {
                    setHead(controlData?.head_department?.id);
                }

               

                if (controlData?.system !== undefined && controlData?.system != "") {
                    setSystem(controlData?.system?.id);
                }

                // Add a small delay to ensure form is ready
                setTimeout(() => {
                    // Use reset to set all form values at once
                    const formData = {
                        name: controlData?.name || "",
                        description: controlData?.description || "",
                        objective: controlData?.objective || "",
                      
                        type: controlData?.type || undefined,
                      
                    };
                    
                   // console.log('Resetting form with data:', formData);
                    reset(formData);
                    
                    // Set additional state values
                    if (controlData?.method == "AUTOMATED") {
                        setSelectedMethod("AUTOMATED");
                    }
                    if (controlData?.method == "ITDM") {
                        setSelectedMethod("ITDM");
                    }
                if (controlData?.icof_id !== undefined && controlData?.icof_id !== null) {
                    setChecked(true);
                    if (controlData?.Assertion) {
                        setIcof(controlData?.Assertion);
                    }
                }
                }, 100);

                setLoading(false);
                setError(false);
            }
        } catch (error: any) {
            //console.error("Error fetching data:", error);
            setLoading(false);
            setError(true);
            setErrorMsg(error.message);
        }
    };
    

    useEffect(() => {
        const fetchControlReferences = async () => {
            try {
                const data = await fetchDataApiRefrence(`control-references/getAll`);
                const options = data.data.map((item: any) => ({
                    value: item.id,
                    label: item.name,
                }));
                setControlReferenceOptions(options);
            } catch (error) {
                //console.error("Error fetching control references:", error);
            }
        };

        fetchControlReferences();
    }, []);


  


    useEffect(() => {
        if (id) {
            const fetchAllData = async () => {
                setIsDataLoading(true);
                setLoading(true);
                try {
                    // Permissions removed for testing; fetch data directly
                    await Promise.all([
                
                        fetchControl()
                    ]);
                } catch (error) {
                    console.error("Error loading data:", error);
                    toast("Error loading data. Please try again.", { type: "error" });
                    setPermissionsShow(false);
                } finally {
                    setIsDataLoading(false);
                    setLoading(false);
                }
            };

            fetchAllData();
        }
    }, [id]);

    const onSubmit = async (data: UpdateControlInput) => {
        setLoadingButton(true);
        setShowErrors(true);

        try {
            const basicPayload = {
                name: data.name,
                description: data.description,
                objective: data.objective,
                type: data.type as any,
            };
            //console.log('Submitting basic control update:', basicPayload);
            const responseData: any = await updateControlBasic(id as string, basicPayload);

            if (responseData) {
                toast("Control updated successfully", { type: "success" });
                setShowPopup(false);
                setIsSaved(true);
                setIsNavigatingAway(true);
                setTimeout(() => {
                    switchToCatalog();
                }, 200);
            } else {
                toast("Failed to update control - No response received", { type: "error" });
            }
        } catch (error: any) {
            console.error('Update control error:', error);
            const errorMessage = error.message || 'Failed to update control';
            toast(errorMessage, { type: "error" });
        } finally {
            setLoadingButton(false);
        }
    };

    const onError = (err: any) => {
        //console.error(err);
        toast("There are errors in the form", { type: "error" });
    };
    const [isModalOpen, setIsModalOpen] = useState(false);

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen); // Toggle modal open/close state
    };
    

    const addAccountType = (newAccountType:any) => {
        setAsserations((prev) => [...prev, newAccountType as Assertion]);
        setIcof(newAccountType); // Optionally select the newly added account type
       // console.log(newAccountType?.id)
        setValue("icof_id", newAccountType?.id); // If using react-hook-form, set the value in the form state

    };
    const [isSaved, setIsSaved] = useState(false); 
    const [isFormNotFilled, setIsFormNotFilled] = useState(false); 
    const [showPopup, setShowPopup] = useState(false); 
    const [isNavigatingAway, setIsNavigatingAway] = useState(false); 
    const [targetPath, setTargetPath] = useState<string | null>(null);
  
   
    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (!isSaved) {
                e.preventDefault();
                e.returnValue = 'You have unsaved changes. Are you sure you want to leave?';
            }
        };
      
        window.addEventListener('beforeunload', handleBeforeUnload);
        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);
        };
    }, [isSaved, location.pathname]);


    const handleLeave = () => {
        setIsSaved(true); // Mark as saved to prevent warning
        setShowPopup(false); 
        if (targetPath) {
            navigate(targetPath); // Navigate to the stored path
        }
    };

  const [formValues, setFormValues] = useState({});




  // Wrapper function for the confirmation modal
  const handleSaveFromModal = () => {
    // Trigger form submission directly
    const form = document.getElementById('control-form') as HTMLFormElement;
    if (form) {
      const submitEvent = new Event('submit', {
        bubbles: true,
        cancelable: true,
      });
      form.dispatchEvent(submitEvent);
    }
  };



  useEffect(() => {

    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (!isSaved) {
        e.preventDefault();
        e.returnValue = ''; // This triggers the browser confirmation dialog
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isSaved]);
  


    if (permissionsError) {
        return (
            <ActionsLayout>
                <div>Error fetching permissions</div>
            </ActionsLayout>
        );
    }
    const loadingOverlay = loading ? (
        <div className="loading-screen" style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
            <div><LoadingScreen/></div>
        </div>
    ) : null;
    if (error) {
        return (
            <ActionsLayout>
                <div>Error...</div>
            </ActionsLayout>
        );
    }

    if (permissionsShow) {
        return (
            <ActionsLayout>
                <div className="bg-red-500 text-white p-4 text-center">
                    You do not have permission to view this page.
                </div>
            </ActionsLayout>
        );
    }

    const handleRiskChange = ($event: any, ind: number) => {
        const selectedRisk = $event.value;
        const isDuplicate = risks_control.some((risk:any) => risk.value === selectedRisk);

        if (!isDuplicate) {
            const newRiskControl = {
                value: selectedRisk,
                label: $event.label,
            };

            const newFunctions = $event.functions.map((func: any) => ({
                label: func.Function.name,
                value: func.Function.id,
                risk_id: selectedRisk,
            }));

            const newProcesses = $event.process.map((proc: any) => ({
                label: proc.process.name,
                value: proc.process.id,
                risk_id: selectedRisk,
            }));

            let updatedRisksControl = [...risks_control];
            updatedRisksControl[ind] = newRiskControl;

            if (newFunctions.length > 0) {
                setFun((prevFun: any[]) => {
                    let updatedFun = [...prevFun];
                    updatedFun[ind] = newFunctions[0];
                    return updatedFun;
                });
            }

            if (newProcesses.length > 0) {
                setProcess((prevProcess: any[]) => {
                    let updatedProcess = [...prevProcess];
                    updatedProcess[ind] = newProcesses[0];
                    return updatedProcess;
                });
            }

            setRisksControl(updatedRisksControl);
            setRiskSelectionError(null);
        } else {
            setRiskSelectionError("You cannot select the same risk");
        }
    };

    const handleDeleteRisk = (index: number) => {
        let newRisksControl = [...risks_control];
        const riskIdToDelete = newRisksControl[index].value;

        newRisksControl = newRisksControl.filter((_, i) => i !== index);

        if (!riskIdToDelete) {
            setFun((prevFun:any[]) => prevFun.filter((_: any, i: number) => i !== index));
            setProcess((prevProcess:any[]) => prevProcess.filter((_: any, i: number) => i !== index));
        } else {
            setFun((prevFun:any[]) => prevFun.filter((func: any) => func.risk_id !== riskIdToDelete));
            setProcess((prevProcess:any[]) => prevProcess.filter((proc: any) => proc.risk_id !== riskIdToDelete));
        }

        setRisksControl(newRisksControl);
    };

    const handleAddButtonClick = ($event:any) => {
        $event.preventDefault();
        const newRiskControl = { label: "", value: "" };
        setRisksControl([...risks_control, newRiskControl]);
        setFun([...fun, { label: "", value: "" }]);
        setProcess([...process, { label: "", value: "" }]);
    };

    return (
     
            <>
            {loadingOverlay}
            <div>
                {loading ? (
                    <LoadingScreen />
                ) : (
                    <>
                        <div className="container ucp-container root" style={{ background: "#fff", minHeight: "100vh" }}>
                            <form  id="control-form"
                                className="mt-4"
                                onSubmit={handleSubmit(onSubmit, onError)}
                                style={{ margin: "auto", paddingBottom: "150px" }}
                            onChangeCapture={(e) => {
                                const target = e.target as HTMLInputElement;
                                if (!target || !target.name) return;
                                setFormValues((prev: any) => ({ ...prev, [target.name]: target.value }));
                                setIsFormNotFilled(true);
                            }}
                            >
                                <label className="ucp-section-title">Details</label>
                                <div className="mt-3 ucp-block">
                                    <Label className="d-flex align-items-center">
                                        What - Control Name <span className="text-danger">*</span>
                                        <Tooltip
                                            content="عنوان الاجراء"
                                            direction="up"
                                            className="mx-2 text-end"
                                            tagName="div"
                                            background="#ddd"
                                        >
                                            <InformationCircleIcon width={20} height={20}></InformationCircleIcon>
                                        </Tooltip>
                                    </Label>

                                    <input
                                        type="text"
                                        id="name"
                                        {...register("name", { required: "You must include a Control name" })}
                                        className="form-control w-90 no-border"
                                    />
                                    <ErrorMessage
                                        errors={showErrors ? errors : {}}
                                        name="name"
                                        render={({ message }) => <p className="w-90 text-danger">{message}</p>}
                                    />
                                </div>

                             

                               
                                <div className="row">
                                    <div className="col-md-6 mt-4">
                                        <Label className="d-flex">
                                            Control Description <span className="text-danger">*</span>
                                            <Tooltip
                                                content={
                                                    <div
                                                        style={{
                                                            maxWidth: "500px",
                                                            width: "400px",
                                                            background: "#ddd",
                                                            padding: "10px",
                                                            whiteSpace: "pre-line",
                                                            textAlign: "right",
                                                        }}
                                                    >
                                                        {description_txt}
                                                    </div>
                                                }
                                                direction="up"
                                                className="mx-2"
                                                tagName="div"
                                            >
                                                <InformationCircleIcon width={20} height={20}></InformationCircleIcon>
                                            </Tooltip>
                                        </Label>

                                        <textarea
                                            {...register("description", {
                                                required: "You must include a control description",
                                            })}
                                            id="description"
                                            className="form-control w-90"
                                        />
                                        <ErrorMessage
                                            errors={showErrors ? errors : {}}
                                            name="description"
                                            render={({ message }) => <p className="w-90 text-danger">{message}</p>}
                                        />
                                    </div>

                                    <div className="col-md-6 mt-4">
                                        <Label className="d-flex">
                                            Control Objective <span className="text-danger">*</span>
                                        </Label>

                                        <textarea
                                            {...register("objective", {
                                                required: "You must include a control objective",
                                            })}
                                            id="objective"
                                            className="form-control w-90"
                                        />
                                        <ErrorMessage
                                            errors={showErrors ? errors : {}}
                                            name="objective"
                                            render={({ message }) => <p className="w-90 text-danger">{message}</p>}
                                        />
                                    </div>
                                </div>

                                
                      
                              
                               
                            

                                <div className="row">
                                    <div className="col-md-6 mt-4">
                                        <Label className="d-flex">
                                            Why - Type <span className="text-danger">*</span>
                                            <Tooltip
                                                content={
                                                    <div
                                                        style={{
                                                            maxWidth: "500px",
                                                            width: "400px",
                                                            background: "#ddd",
                                                            padding: "10px",
                                                            whiteSpace: "pre-line",
                                                            textAlign: "right",
                                                        }}
                                                    >
                                                        {`الهدف من الاجراء " هل هو لمنع حدوث الخطر ام لاكتشاف حدوث الخطر ام لتصحيح العواقب او نتائج حدوث الخطر  او لاكتشاف و تصحيح الخطر فى نفس الوقت`}
                                                    </div>
                                                }
                                                direction="up"
                                                className="mx-5"
                                                tagName="div"
                                            >
                                                <InformationCircleIcon width={20} height={20}></InformationCircleIcon>
                                            </Tooltip>
                                        </Label>
                                        <select
                                            {...register("type", { required: "You must select a type " })}
                                            id="type"
                                            className="form-select w-90"
                                        >
                                            <option value="">Please select a value</option>
                                            <option value="Preventive">Preventive</option>
                                            <option value="Detective">Detective</option>
                                            <option value="Corrective">Corrective</option>
                                            <option value="Directive">Directive</option>
                                            <option value="Detective And Corrective">Detective And Corrective</option>
                                        </select>
                                        <ErrorMessage
                                            errors={showErrors ? errors : {}}
                                            name="type"
                                            render={({ message }) => <p className="text-danger">{message}</p>}
                                        />
                                    </div>

                                 
                                </div>

                               
                           

                          
                         
                               
                                <div className="col-span-3 mt-5 px-5 text-center">
                                    <Button
                                        style={{ width: "130px" }}
                                        type="submit"
                                        className="mx-auto font-bold  text-white mt-5 m-5 p-3  bg-primary  hover:bg-orange-600 rounded-lg mr-3"
                                        disabled={isLoadingButton || isDataLoading}
                                        variant={"secondary"}
                                    >
                                        {isDataLoading ? "Loading Data..." : isLoadingButton ? "Loading..." : "Save Control"}
                                    </Button>
                                </div>
                            </form>
                        </div>
                    </>
                )}

<ConfirmationModal
        isVisible={showPopup}
        onClose={handleLeave}
        onSave={handleSaveFromModal}
        isLoading={false}
      />



                <CreateAccountType isOpen={isModalOpen} onClose={toggleModal} addAccountType={addAccountType} />
            </div>
      </>
    );
};
export default UpdateControlPage;
